import type { EndpointDefinition } from "../../_sdk/types/common";

export const apiName = "workspaces";

export const endpoints: { [key: string]: EndpointDefinition } = {
    getWorkspaceResources: {
        route: "/workspaces/:workspaceId/resources",
        method: "GET"
    },
    updateWorkspaceResource: {
        route: "/workspaces/:workspaceId/resources/:resourceType/:resourceId",
        method: "PUT"
    },
    deleteWorkspaceResource: {
        route: "/workspaces/:workspaceId/resources/:resourceType/:resourceId",
        method: "DELETE"
    },
    createWorkspaceResource: {
        route: "/workspaces/:workspaceId/resources",
        method: "POST"
    }
};
